import { object, number } from 'yup';

export const ticketDistributionSchema = object().shape({
  quantity: number()
    .min(1, 'Quantity must be greater than 0')
    .max(100, 'Maximum quantity is 100')
    .required('Required field'),
});
